import SiteHeader from '../komponenter/SiteHeader';
import HomeAboutSection from '../komponenter/home/HomeAboutSection';
import HomeContactFooter from '../komponenter/home/HomeContactFooter';
import HomeErrorBanner from '../komponenter/home/HomeErrorBanner';
import HomeHeroSection from '../komponenter/home/HomeHeroSection';
import HomePropertyOverviewSection from '../komponenter/home/HomePropertyOverviewSection';
import HomePropertyTypesSection from '../komponenter/home/HomePropertyTypesSection';
import HomeStatsSection from '../komponenter/home/HomeStatsSection';
import { useHomePage } from '../hooks/useHomePage';

function HomePage() {
  const {
    activeFilter,
    activeType,
    availableTypes,
    canBrowseProperties,
    filteredProperties,
    goToNextPage,
    goToPreviousPage,
    handleFilterChange,
    handleSearchChange,
    handleSortChange,
    handleTypeChange,
    handleUnitsChange,
    isLoading,
    loadError,
    minUnits,
    normalizedStartIndex,
    portfolioStats,
    resetFilters,
    searchTerm,
    settings,
    sortKey,
    visibleProperties,
  } = useHomePage();

  const portfolioReturnUrl = `/?filter=${activeFilter}&start=${normalizedStartIndex}#eiendommer`;

  return (
    <div className="text-[#183228]">
      <SiteHeader />
      <HomeHeroSection
        brandName={settings.brandName}
        heroDescription={settings.heroDescription}
        heroTitle={settings.heroTitle}
        highlights={settings.highlights}
      />

      <main>
        <HomeErrorBanner loadError={loadError} />
        <HomeStatsSection portfolioStats={portfolioStats} />
        <HomeAboutSection />
        <HomePropertyTypesSection propertyTypes={settings.propertyTypes} />
        <HomePropertyOverviewSection
          activeFilter={activeFilter}
          activeType={activeType}
          availableTypes={availableTypes}
          canBrowseProperties={canBrowseProperties}
          filteredProperties={filteredProperties}
          goToNextPage={goToNextPage}
          goToPreviousPage={goToPreviousPage}
          handleFilterChange={handleFilterChange}
          handleSearchChange={handleSearchChange}
          handleSortChange={handleSortChange}
          handleTypeChange={handleTypeChange}
          handleUnitsChange={handleUnitsChange}
          isLoading={isLoading}
          minUnits={minUnits}
          portfolioReturnUrl={portfolioReturnUrl}
          resetFilters={resetFilters}
          searchTerm={searchTerm}
          sortKey={sortKey}
          visibleProperties={visibleProperties}
        />
      </main>
      <HomeContactFooter />
    </div>
  );
}

export default HomePage;